import {
  CLONEDATA,
  CONTRACTSTATUS,
  CURRENTTAB,
  FORMACTIVED,
  NEWTAB,
  PACKAGES,
  PRODUCTINFORS,
  PRODUCTVALIDATION,
} from '../../healthInsurance/redux/action'
import * as Effects from 'redux-saga/effects'
import {ActionTypes, CURRENCYINFOS, FEEANDTAX} from './actions'
import {motoInitialState} from './model'
import moment from 'moment'
import {
  calculateDate,
  CalculateTimeInsured,
  FormateContractPayment,
  formatter,
  validateSpecialChar,
} from '../../../../utils'
import {INSUREDFILTER, OWNERINFO} from '../../AutoInsurance/redux/action'
import {step2GetObjectInsuredMotoList, step2GetObjectInsuredMotoByID} from '../apis'
import {step4GetContractByID} from '../../healthInsurance/apis'

const call: any = Effects.call
const takeLatest = Effects.takeLatest
const put = Effects.put

export const actions = {
  addNewTab: (tab: NEWTAB) => ({type: 'ADDNEWMOTO', payload: tab}),
  modifyTab: (tab: CURRENTTAB) => ({type: 'MODIFYTABMOTO', payload: tab}),
  activeFormMoto: (active: FORMACTIVED) => ({type: 'ACTIVEFORMMOTO', payload: active}),
  removeTab: (tab: string) => ({type: 'REMOVETABMOTO', payload: tab}),
  addMotoInfos: (data: PRODUCTINFORS) => ({type: 'ADDMOTOINFORS', payload: data}),
  updateMotoCurrencyInfos: (data: CURRENCYINFOS) => ({
    type: 'UPDATEMOTOCURRENCYINFOS',
    payload: data,
  }),
  validateFormMoto: (data: PRODUCTVALIDATION) => ({type: 'VALIDATEFORMMOTO', payload: data}),
  saveMotoPackageInsurances: (data: PACKAGES) => ({
    type: 'SAVEMOTOPACKAGEINSURANCES',
    payload: data,
  }),
  updateMotoContractStatus: (data: CONTRACTSTATUS) => ({
    type: 'UPDATEMOTOCONTRACTSTATUS',
    payload: data,
  }),
  clearDataFormMoto: (data: CLONEDATA) => ({
    type: 'CLEARDATAFORMMOTO',
    payload: data,
  }),
  cloneDataFormMoto: (data: CLONEDATA) => ({
    type: 'CLONEDATAFORMMOTO',
    payload: data,
  }),
  getListMotoInsured: (data: INSUREDFILTER) => ({
    type: 'GETLISTMOTOINSURED',
    payload: data,
  }),
  saveListMotoInsured: (data: any) => ({
    type: 'SAVELISTMOTOINSURED',
    payload: data,
  }),
  getMotoInsuredById: (data: any) => ({
    type: 'GETMOTOINSUREDBYID',
    payload: data,
  }),
  saveMotoInsured: (data: any) => ({
    type: 'SAVEMOTOINSURED',
    payload: data,
  }),
  updateMotoFeeTax: (data: FEEANDTAX) => ({
    type: 'UPDATEFEETAX',
    payload: data,
  }),
  getMotoContractStep4ById: (data: any) => ({type: 'GETMOTOCONTRACTSTEP4BYID', payload: data}),
  saveMotoContractStep4ById: (data: any) => ({
    type: 'SAVEMOTOCONTRACTSTEP4BYID',
    payload: data,
  }),
  updateMotoInsuredOwner: (data: OWNERINFO) => ({
    type: 'UPDATEMOTOINSUREDOWNER',
    payload: data,
  }),
}

export const motoInsuReducer = (state = motoInitialState, action: ActionTypes) => {
  switch (action.type) {
    case 'ADDNEWMOTO':
      const newTabState = JSON.parse(JSON.stringify(state))
      if (newTabState.length === 1 && newTabState[0].tabName == undefined) {
        newTabState[0].tabName = action.payload.tab
        newTabState[0].sellingContractId = action.payload.tab
        newTabState[0].customerCode = action.payload.customerCode
        newTabState[0].customerVersion = action.payload.customerVersion
        newTabState[0].contractType = action.payload.contractType
        newTabState[0].contractKind = action.payload.contractKind
        newTabState[0].originalContract = action.payload.originalContract
        newTabState[0].groupDomainCode = action.payload.groupDomainCode
        newTabState[0].form.activeForm = 1
      } else {
        const obj = {
          tabName: action.payload.tab,
          sellingContractId: action.payload.tab,
          customerCode: action.payload.customerCode,
          customerVersion: action.payload.customerVersion,
          groupDomainCode: action.payload.groupDomainCode,
          contractType: action.payload.contractType,
          contractKind: action.payload.contractKind,
          originalContract: action.payload.originalContract,
          packageExtension: undefined,
          packageInsurance: undefined,
          form: {
            activeForm: 1,
            formStatus: null,
            formData: {
              formMotoInsurancePlan: {
                businessProgramCode: null,
                productCode: 'MOTOBIKE',
                exploitingType: null,
                exploitingCode: null,
                typeOfIntroduction: null,
                introductionCode: null,
                curencyMoney: null,
                curencyFee: null,
                exchangeRate: '1',
                exchangeRateNote: null,
                business: null,
                businessName: null,
                currencyFeeChange: null,
                validateForm: null,
                tpa: null,
                tpaType: null,
                tpaFee: null,
                adjacentContractNumberLoss: null,
                adjacentContractNumber: null,
                paymentTimeType: null,
                calculationType: '0',
                nationality: null,
              },
              formMotoListInsured: {
                id: null,
                certType: null,
                certNumber: null,
                ownerCode: null,
                ownerVersion: null,
                oldContractCode: null,
                vehicleOwner: null,
                address: null,
                licensePlate: null,
                chassisNumber: null,
                engineNumber: null,
                timeDuration: null,
                startDate: moment().format('YYYY/MM/DD HH:mm'),
                expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
                objectInsuredType: null,
                manufacturingYear: null,
                seat: null,
                bikeCompany: null,
                bikeBrand: null,
                vehicleGroupsCode: null,
                packageCode: null,
                sumFee: null,
                sumTax: null,
                validateForm: null,
                listMoto: null,
                payeeName: null,
                payeeNameIdentificationNumber: null,
                payeesRelationsShip: null,
                payeePhone: null,
                payeeEmail: null,
                packageChoosed: null,
                listObjectSelected: null,
                vehiclePackageBenefitDtos: null,
                fieldInput: [],
                nationality: null,
              },
              formMotoContract: {
                agency: null,
                contractType: null,
                contractNumber: null,
                originalCode: null,
                created: null,
                purchaseDate: null,
                startDate: null,
                expireDate: null,
                manager: null,
                totalPerson: null,
                sumFee: null,
                partyARepresentative: null,
                partyAPosition: null,
                partyBRepresentative: null,
                partyBPosition: null,
                partyBPhone: null,
                partyAPhone: null,
                partyAPowerOfAttorney: null,
                partyBPowerOfAttorney: null,
                partyBFax: null,
                proxy: null,
                bankCode: null,
                sumTax: null,
                taxType: '1',
                bankNumber: null,
                _sellingContractPaymentScheduleDtos: null,
                _sellingContractExtraDataDtos: null,
                lossRatio: null,
                validateForm: null,
                exploName: null,
                exploManager: null,
                exploitingType: null,
                tsIncharge: null,
                pmIncharge: null,
                paymentTimeType:null,
                commission: '0',
                adminFee: '0',
                vatAdminFee: null,
                endorStartDate: null,
                endorExpireDate: null,
                endorNote: null,
                userReceiveMail: null,
                customerConfirmDate: null,
              },
            },
          },
        }
        newTabState.push(obj)
      }
      return newTabState
    case 'REMOVETABMOTO':
      const removeTabState = JSON.parse(JSON.stringify(state))
      const tabRemoved = removeTabState.filter((o: any) => o.tabName !== action.payload)
      return tabRemoved
    case 'MODIFYTABMOTO':
      const modifyTabState = JSON.parse(JSON.stringify(state))
      const currentModifyTab = modifyTabState.find(
        (o: any) => o.tabName == action.payload.currentTab
      )
      if (currentModifyTab) {
        currentModifyTab.sellingContractId = action.payload.newTabName
        currentModifyTab.customerCode = action.payload.customerCode
        currentModifyTab.customerVersion = action.payload.customerVersion
        currentModifyTab.groupDomainCode = action.payload.groupDomainCode
      }
      return modifyTabState
    case 'ADDMOTOINFORS':
      const addProductTabState = JSON.parse(JSON.stringify(state))
      const {key, value, tab, form} = action.payload
      let addProductTab = addProductTabState.find((o: any) => o.tabName == tab)
      if (addProductTab) {
        addProductTab.form.formData[form][key] = value
        if (key == 'price') {
          if (value && value !== '' && typeof value == 'string') {
            let convert = value.replaceAll(',', '')
            if (!isNaN(parseInt(convert))) {
              let test = validateSpecialChar(value)
              if (!test) {
                addProductTab.form.formData[form][key] = formatter(parseInt(convert))
              } else addProductTab.form.formData[form][key] = formatter(parseInt(value))
            } else addProductTab.form.formData[form][key] = null
          } else if (typeof value == 'number') {
            addProductTab.form.formData[form][key] = formatter(value)
          }
        }
        // if (form == 'formAutoOfferFee') {
        //   if (key == 'startDate') {
        //     let dataCalculated = calculateDate(value, true)
        //     addProductTab.form.formData.formAutoOfferFee.expireDate = dataCalculated
        //   }
        // }
        // if (form == 'formMotoListInsured') {
        //   if (key == 'startDate') {
        //     let dataCalculated = calculateDate(value, true)
        //     addProductTab.form.formData.formMotoListInsured.expireDate = dataCalculated
        //   }
        // }
      }
      return addProductTabState
    case 'UPDATEMOTOCURRENCYINFOS':
      const motoCurrencyState = JSON.parse(JSON.stringify(state))
      const motoCurrencyTab = motoCurrencyState.find((o: any) => o.tabName == action.payload.tab)
      if (motoCurrencyTab) {
        motoCurrencyTab.form.formData.formMotoInsurancePlan.curencyMoney =
          action.payload.curencyMoney
        motoCurrencyTab.form.formData.formMotoInsurancePlan.curencyFee = action.payload.curencyFee
      }
      return motoCurrencyState
    case 'ACTIVEFORMMOTO':
      const activeFormState = JSON.parse(JSON.stringify(state))
      let currentTab = activeFormState.find((o: any) => o.tabName == action.payload.tab)
      if (currentTab) {
        currentTab.form.activeForm = action.payload.form
      }
      return activeFormState
    case 'VALIDATEFORMMOTO':
      const validateState = JSON.parse(JSON.stringify(state))
      const validateTab = validateState.find((o: any) => o.tabName == action.payload.tab)
      if (validateTab) {
        validateTab.form.formData[action.payload.form].validateForm = action.payload.isError
      }
      return validateState
    case 'SAVEMOTOPACKAGEINSURANCES':
      const packageInsuranceState = JSON.parse(JSON.stringify(state))
      const packageInsuranceTab = packageInsuranceState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (packageInsuranceTab) {
        packageInsuranceTab.packageInsurance = action.payload.data
        // packageInsuranceTab.form.formData.formPersonOfferFee.packageCode = null
      }
      return packageInsuranceState
    case 'UPDATEMOTOCONTRACTSTATUS':
      const contractStatusState = JSON.parse(JSON.stringify(state))
      let contractStatusTab = contractStatusState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (contractStatusTab) {
        contractStatusTab.form.formStatus = action.payload.status
      }
      return contractStatusState
    case 'CLONEDATAFORMMOTO':
      const cloneState = JSON.parse(JSON.stringify(state))
      const cloneTab = cloneState.find((o: any) => o.tabName == action.payload.tab)
      if (cloneTab) {
        cloneTab.form.formData[action.payload.form].id = null
        if ((action.payload.form = 'formMotoListInsured')) {
          cloneTab.form.formData[action.payload.form].vehicleOwner = null
          cloneTab.form.formData[action.payload.form].address = null
          cloneTab.form.formData[action.payload.form].licensePlate = null
          cloneTab.form.formData[action.payload.form].chassisNumber = null
          cloneTab.form.formData[action.payload.form].engineNumber = null
        }
      }
      return cloneState
    case 'CLEARDATAFORMMOTO':
      const cleanState = JSON.parse(JSON.stringify(state))
      const cleanTab = cleanState.find((o: any) => o.tabName == action.payload.tab)
      if (cleanTab) {
        for (const o in cleanTab.form.formData[action.payload.form]) {
          if (action.payload.form == 'formMotoListInsured') {
            if (
              o !== 'startDate' &&
              o !== 'expireDate' &&
              o !== 'listMoto' &&
              o !== 'certType' &&
              o !== 'objectInsuredType' &&
              o !== 'fieldInput'
            ) {
              cleanTab.form.formData[action.payload.form][o] = null
            } else if (o == 'startDate') {
              let date = moment().format('YYYY/MM/DD HH:mm')
              cleanTab.form.formData[action.payload.form][o] = date
              let dataCalculated = calculateDate(date, true)
              cleanTab.form.formData[action.payload.form].expireDate = dataCalculated
            } else if (o == 'objectInsuredType') {
              cleanTab.form.formData[action.payload.form][o] = '1'
            }
          }
        }
      }
      return cleanState
    case 'GETLISTMOTOINSURED':
      return state
    case 'SAVELISTMOTOINSURED':
      const motoInsuredListState = JSON.parse(JSON.stringify(state))
      const motoInsuredListTab = motoInsuredListState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (motoInsuredListTab) {
        if (action.payload.data && action.payload.data.items) {
          action.payload.data.items.map((o: any) => {
            o.packageName = motoInsuredListTab.packageInsurance.package.vehiclePackagesDtos.find(
              (x: any) => x.code == o.packageCode
            )?.name
            o.fee = formatter(o.sumFee + o.sumTax)
          })
          motoInsuredListTab.form.formData.formMotoListInsured.listMoto = action.payload.data.items
        }
      }
      return motoInsuredListState
    case 'GETMOTOINSUREDBYID':
      return state
    case 'SAVEMOTOINSURED':
      const motoInfoState = JSON.parse(JSON.stringify(state))
      const motoInfoStateTab = motoInfoState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (motoInfoStateTab) {
        motoInfoStateTab.form.formData.formMotoListInsured.packageCode =
          action.payload.data.packageCode
        motoInfoStateTab.form.formData.formMotoListInsured.id = action.payload.data.id
        motoInfoStateTab.form.formData.formMotoListInsured.certType = action.payload.data.certType
        motoInfoStateTab.form.formData.formMotoListInsured.certNumber =
          action.payload.data.certNumber
        motoInfoStateTab.form.formData.formMotoListInsured.objectInsuredType =
          action.payload.data.objectInsuredType
        motoInfoStateTab.form.formData.formMotoListInsured.vehicleGroupsCode =
          action.payload.data._sellingContractBikeDtos[0].vehicleGroupsCode
        motoInfoStateTab.form.formData.formMotoListInsured.vehicleOwner =
          action.payload.data._sellingContractBikeDtos[0].vehicleOwner
        motoInfoStateTab.form.formData.formMotoListInsured.address =
          action.payload.data._sellingContractBikeDtos[0].address
        motoInfoStateTab.form.formData.formMotoListInsured.bikeCompany =
          action.payload.data._sellingContractBikeDtos[0].bikeCompany
        motoInfoStateTab.form.formData.formMotoListInsured.bikeBrand =
          action.payload.data._sellingContractBikeDtos[0].bikeBrand
        motoInfoStateTab.form.formData.formMotoListInsured.licensePlate =
          action.payload.data._sellingContractBikeDtos[0].licensePlate
        motoInfoStateTab.form.formData.formMotoListInsured.chassisNumber =
          action.payload.data._sellingContractBikeDtos[0].chassisNumber
        motoInfoStateTab.form.formData.formMotoListInsured.engineNumber =
          action.payload.data._sellingContractBikeDtos[0].engineNumber
        motoInfoStateTab.form.formData.formMotoListInsured.manufacturingYear =
          action.payload.data._sellingContractBikeDtos[0].manufacturingYear
        motoInfoStateTab.form.formData.formMotoListInsured.startDate = moment(
          action.payload.data.startDate,
          'DD/MM/YYYY HH:mm'
        ).format('YYYY/MM/DD HH:mm')
        motoInfoStateTab.form.formData.formMotoListInsured.expireDate = moment(
          action.payload.data.expireDate,
          'DD/MM/YYYY HH:mm'
        ).format('YYYY/MM/DD HH:mm')
        motoInfoStateTab.form.formData.formMotoListInsured.timeDuration = CalculateTimeInsured(
          motoInfoStateTab.form.formData.formMotoListInsured.startDate,
          motoInfoStateTab.form.formData.formMotoListInsured.expireDate
        )
        motoInfoStateTab.form.formData.formMotoListInsured.sumFee = action.payload.data.sumFee
        motoInfoStateTab.form.formData.formMotoListInsured.sumTax = action.payload.data.sumTax
        motoInfoStateTab.form.formData.formMotoListInsured.feeCar = action.payload.data.sumFee
        motoInfoStateTab.form.formData.formMotoListInsured.payeeNameIdentificationNumber =
          action.payload.data.payeeNameIdentificationNumber
        motoInfoStateTab.form.formData.formMotoListInsured.payeeName = action.payload.data.payeeName
        motoInfoStateTab.form.formData.formMotoListInsured.payeesRelationsShip =
          action.payload.data.payeesRelationsShip
        action.payload.data._sellingContractBikeBenefitDtos.map((o: any) => {
          o.isChecked = true
        })
        motoInfoStateTab.form.formData.formMotoListInsured.vehiclePackageBenefitDtos =
          action.payload.data._sellingContractBikeBenefitDtos
      }
      return motoInfoState
    case 'UPDATEFEETAX':
      const feeTaxTabState = JSON.parse(JSON.stringify(state))
      let feeTaxTab = feeTaxTabState.find((o: any) => o.tabName == action.payload.tab)
      if (feeTaxTab) {
        feeTaxTab.form.formData[action.payload.form].sumFee = action.payload.fee
        feeTaxTab.form.formData[action.payload.form].sumTax = action.payload.tax
      }
      return feeTaxTabState
    case 'GETMOTOCONTRACTSTEP4BYID':
      return state
    case 'SAVEMOTOCONTRACTSTEP4BYID':
      const saveContractState = JSON.parse(JSON.stringify(state))
      const saveContractTab = saveContractState.find(
        (o: any) => o.sellingContractId == action.payload.id
      )
      if (saveContractTab) {
        saveContractTab.form.formData.formMotoContract.contractNumber =
          action.payload.contractNumber
        saveContractTab.form.formData.formMotoContract.created = moment(
          action.payload.createdDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formMotoContract.contractType = action.payload.contractType
        saveContractTab.form.formData.formMotoContract.startDate = moment(
          action.payload.startDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formMotoContract.purchaseDate = moment(
          action.payload.purchaseDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formMotoContract.manager = action.payload.manager
        saveContractTab.form.formData.formMotoContract.expireDate = moment(
          action.payload.expireDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formMotoContract.totalPerson = action.payload.amountPeople
        saveContractTab.form.formData.formMotoContract.adjacentContractNumber =
          action.payload.adjacentContractNumber
        saveContractTab.form.formData.formMotoContract.adjacentContractNumberLoss =
          action.payload.adjacentContractNumberLoss
        saveContractTab.form.formData.formMotoContract.partyARepresentative =
          action.payload.partyARepresentative
        saveContractTab.form.formData.formMotoContract.partyBRepresentative =
          action.payload.partyBRepresentative
        saveContractTab.form.formData.formMotoContract.partyAPowerOfAttorney =
          action.payload.partyAPowerOfAttorney
        saveContractTab.form.formData.formMotoContract.partyBPowerOfAttorney =
          action.payload.partyBPowerOfAttorney
        saveContractTab.form.formData.formMotoContract.partyAPosition =
          action.payload.partyAPosition
        saveContractTab.form.formData.formMotoContract.partyBFax = action.payload.partyBFax
        saveContractTab.form.formData.formMotoContract.partyBPhone = action.payload.partyBPhone
        saveContractTab.form.formData.formMotoContract.partyAPhone = action.payload.partyAPhone
        saveContractTab.form.formData.formMotoContract.partyBPosition =
          action.payload.partyBPosition
        saveContractTab.form.formData.formMotoContract.bankCode = action.payload.bankCode
        saveContractTab.form.formData.formMotoContract.bankNumber = action.payload.bankNumber
        saveContractTab.form.formData.formMotoContract._sellingContractPaymentScheduleDtos =
          FormateContractPayment(action.payload._sellingContractPaymentScheduleDtos)
        saveContractTab.form.formData.formMotoContract._sellingContractExtraDataDtos =
          action.payload._sellingContractExtraDataDtos
        saveContractTab.form.formData.formMotoContract.sumFee = formatter(action.payload.sumFee)
        saveContractTab.form.formData.formMotoContract.sumTax = formatter(action.payload.sumTax)
        saveContractTab.form.formData.formMotoContract.taxType = action.payload.taxType
      }
      return saveContractState
    case 'UPDATEMOTOINSUREDOWNER':
      const motoInsuredOwnerState = JSON.parse(JSON.stringify(state))
      let motoInsuredOwnersTab = motoInsuredOwnerState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (motoInsuredOwnersTab) {
        motoInsuredOwnersTab.form.formData.formMotoListInsured.vehicleOwner =
          action.payload.ownerName
        motoInsuredOwnersTab.form.formData.formMotoListInsured.address = action.payload.ownerAddress
      }
      return motoInsuredOwnerState
    default:
      return state
  }
}

export function* saga() {
  yield takeLatest('GETLISTMOTOINSURED', function* getListMotoInsuredSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetObjectInsuredMotoList, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveListMotoInsured(param))
      }
    } catch (error) {
      return
    }
  })

  yield takeLatest('GETMOTOINSUREDBYID', function* getListCarInsuredByID(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetObjectInsuredMotoByID, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveMotoInsured(param))
      }
    } catch (error) {
      return
    }
  })

  yield takeLatest('GETMOTOCONTRACTSTEP4BYID', function* getMotoContractStep4ByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step4GetContractByID, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveMotoContractStep4ById(response.data))
      }
    } catch (error) {
      return
    }
  })
}
